/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'

export function deleteManagementReportTemplate () {
  return rest.delete('/api/management-reports/template/file')
}

export function downloadManagementTemplate () {
  return rest.get('/api/management-reports/template/file')
    .then(handleBlobResponse)
}

export function fetchManagementReportTemplate (): Promise<S3TemplateMeta> {
  return rest.get('/api/management-reports/template')
    .then((resp) => resp.json())
}

export function uploadManagementReportTemplate (file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return rest.put('/api/management-reports/template/file', { body: fd })
    .then((resp) => resp.json())
}
